module.exports = __webpack_public_path__ + "img/4dbed6b6d69532364dc6bed4e372bd32.4dbed6b6.png";